<template lang="pug">
form-item-wrapper(v-bind="bind", :showMessage="false", :rules="myRules")
  template(v-if="isEdit")
    el-button(icon="el-icon-plus", type="text", @click="open") 添加
    el-button(type="text", @click="clear") 清空
  user-list(v-if="userList", v-bind="userBind", @delete="removeUser")
</template>
<script>
import selectUser from "@/CommonDP/components/custom-dialog/select-user.vue";
import { cloneDeep, mapVFAssignField, staticMixins } from "@/CommonDP/VForm/utils";
import UserList from "@/CommonDP/components/userList/index.vue";
import { USER_ENUM } from "./utils.js";
import { openMember, openH5Member } from "@/CommonDP/components/chooseMember/leftCom.js";
const separator = ",";
export default {
  components: { selectUser, UserList },
  mixins: [staticMixins],
  inheritAttrs: false,
  data() {
    return {
      template: { visible: false },
      rules: []
    };
  },
  computed: {
    ...mapVFAssignField(["assignToName", "assignToUserName", "assignToId"]),
    vmDefaultValue() {
      const {
        options: { defaultUser, defaultUserType }
      } = this;
      const userList = defaultUserType === USER_ENUM.cur_user ? [this.$store.state.user.userInfo] : defaultUser;
      return cloneDeep(userList).map(this.lightUserFn);
    },
    myRules() {
      return [
        ...this.rules,
        {
          type: "array",
          required: this.options.required,
          message: this.options.requiredHint
        },
        {
          type: "array",
          max: this.options.max,
          min: this.options.min,
          message: "人员数量不符合要求"
        }
      ];
    },
    userMax() {
      const {
        options: { single, max }
      } = this;
      return single ? 1 : max;
    },
    userBind() {
      const {
        isEdit,
        fieldModel: list,
        options: { showAvatar: avatar, showUserName: jobNo, ...options }
      } = this;
      return {
        list,
        avatar,
        jobNo,
        ...options,
        disabled: !isEdit
      };
    },
    userList() {
      return this.fieldModel || [];
    }
  },
  watch: {
    // 监听当前值获取获取用户信息
    fieldModel: {
      immediate: true,
      handler: "updateAssign"
    }
  },
  methods: {
    async open() {
      this.preventPreview();
      this.preventDesign();
      const openUser = this.isH5 ? openH5Member : openMember;
      const {
        userMax,
        options: { candateValues, candateRangeType: type }
      } = this;
      let users = [];
      const props = {
        isLowcode: true,
        filterOneself: false,
        codePri: ["User"],
        max: userMax,
        userIds: this.userList.map((e) => e.userId)?.join(",")
      };
      // type: 1根据组织架构搜索 2根据系统角色搜索 3指定部门搜索 4当前用户部门搜索 5根据专业角色搜索 6根据当前项目搜索 7根据指定标签搜索 8系统角色查询所有及人员 9专业角色查询所有及人员 10系统标签查询所有及人员
      if (type === USER_ENUM.range_all) {
        props.isLowcode = false;
        props.prjId = this.prjId;
      } else if (type === USER_ENUM.frameWork) {
        // 组织架构选人
        props.type = 1;
      } else if (type === USER_ENUM.dept) {
        // 指定部门选人
        props.type = 3;
        props.deptId = candateValues.map(({ deptId }) => deptId).join(",");
      } else if (type === USER_ENUM.cur_dept) {
        // 当前部门
        props.type = 4;
        props.curDeptId = "cur";
      } else if (type === USER_ENUM.prj) {
        // 当前项目
        props.type = 6;
        props.prjId = this.prjId;
      } else if (type === USER_ENUM.specRole) {
        // 专业角色
        props.type = 5;
        props.prjId = this.prjId;
        props.specRoleId = candateValues.map((e) => e.userId).join(",");
      } else if (type === USER_ENUM.role) {
        // 系统角色
        props.type = 2;
        props.sysRoleId = candateValues.map((e) => e.userId).join(",");
      } else {
        this.throwErr("不支持的人员范围");
      }
      users = await openUser(props);
      this.updateValue(users);
      this.emitValidate();
    },
    getSelection() {
      const { fieldModel } = this;
      return fieldModel.map((raw) => ({ raw, id: raw.userId, label: raw.name }));
    },
    clear() {
      this.updateValue([]);
      this.emitValidate();
    },
    async removeUser(id) {
      this.preventDesign();
      await this.$confirm("确认删除?", "警告", { type: "warning" });
      const { fieldModel } = this;
      const list = fieldModel.filter(({ userId }) => userId !== id);
      this.updateValue(list);
      this.emitValidate();
    },
    lightUserFn({ userId, userName, name, username }) {
      return { userId, userName: userName || username, name };
    },
    // 触发form数据更新
    updateValue(value) {
      const list = value || [];
      this.fieldModel = list.map(this.lightUserFn);
    },
    // 主值变化的时候,触发方法
    async updateAssign() {
      await this.$nextTick();
      const { fieldModel } = this;
      const list = fieldModel || [];
      this.assignToUserName = list.map(({ userName }) => userName).join(separator);
      this.assignToName = list.map(({ name }) => name).join(separator);
      this.assignToId = list.map(({ userId }) => userId).join(separator);
    }
  }
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
